import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("ak_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

// Trigger for the global Consult dialog (used by all Book a Consult / Apply buttons)
export function openConsult(pkgLabel = "Book a Consult") {
  if (typeof window !== "undefined") {
    window.__askConsultPackage = pkgLabel;
    if (window.location.hash === "#consult") {
      window.dispatchEvent(new HashChangeEvent("hashchange"));
    } else {
      window.location.hash = "#consult";
    }
  }
}

export const SOCIAL = {
  instagram: "askkimberley.dog",
  instagram_url: "https://instagram.com/askkimberley.dog",
  tiktok: "askkimberley.dog",
  tiktok_url: "https://tiktok.com/@askkimberley.dog",
};

export const ASSETS = {
  portrait:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_bark-help/artifacts/05rxl2s6_3B035D06-47FE-40FC-BAC9-184C3496BC8C.PNG",
  portrait_about:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_bark-help/artifacts/05rxl2s6_3B035D06-47FE-40FC-BAC9-184C3496BC8C.PNG",
  peace_chews:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_bark-help/artifacts/ypmysvgz_59B837C8-A50A-4EDE-BDBB-1803327624A9%20%282%29.PNG",
  off_duty:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_bark-help/artifacts/en5szddz_Gemini_Generated_Image_%20%281%29.png",
  xoxo_bobo:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_bark-help/artifacts/zpzrzx0l_Gemini_Generated_Image_ppvygmppvygmppvy.png",
  vogue_hero:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_bark-help/artifacts/5qb3gapy_ChatGPT%20Image%20Sep%2010%2C%202026%2C%2011_06_20%20AM.png",
  private_consultancy_hero:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_bark-help/artifacts/jxq8frxs_ChatGPT%20Image%20Sep%2011%2C%202026%2C%2002_12_01%20PM.png",
  miles_hero:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_bark-help/artifacts/5lor393g_The%20Miles.png",
  logo_la_maison:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_bark-help/artifacts/rv1qddpq_La%20Maison%20des%20Paws%20Logo.jpg",
  logo_firestone:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_bark-help/artifacts/udhgmncb_Firestone.png",
  logo_big_dogs:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_bark-help/artifacts/xye79c3h_Logo2rev2-01.webp",
  logo_kiwi_pet:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_bark-help/artifacts/3l2ijaw2_Gemini_Generated_Image_adqtfhadqtfhadqt.jpg",
  logo_westpac:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_bark-help/artifacts/dgdelgya_Westpac%20Business%20Awards.png",
  jan2027_teaser:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_bark-help/artifacts/i0s6phbw_ChatGPT%20Image%20Sep%2010%2C%202026%2C%2011_07_26%20AM.png",
  business_dog:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_bark-help/artifacts/9aa3n10t_Gemini_Generated_Image_jhke1fjhke1fjhke.jpg",
  editorial:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_bark-help/artifacts/wn21v8p8_Generated%20with%20Kive.ai%20-%20Ask%20Kimberley.png",
  disco_q:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_bark-help/artifacts/gufrsbcv_Photoroom_20260624_161128.JPG",
  disco_q_pink:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_bark-help/artifacts/e8bpy0nc_Generated%20with%20Kive.ai%20-%20Ask%20Kimberley.png",
  portfolio_hero:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_bark-help/artifacts/hwei74kf_ChatGPT%20Image%20Aug%2024%2C%202026%2C%2002_30_57%20PM.png",
};
